import { useQuery } from '@tanstack/react-query';
import { PromotionApi } from 'api/ApiHelper';
import { promotionsQueryKey } from 'queries/promotions/queryKey';

export const useGetPromotionParticipatesQuery = (promotionId: number) =>
  useQuery({
    queryKey: promotionsQueryKey.participates(promotionId),
    queryFn: () => PromotionApi.getParticipates(promotionId),
    gcTime: 0,
  });
